"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addExecuteQuery;
/**
 * Adds an executeQuery function to the SP ClientContext that calls the
 * executeQueryAsync function and returns a promise.
 *
 * @example
 * const ctx = window.SP.ClientContext.get_current();
 * const item = ctx.get_web().getList(list).getItemById(id);
 * addExecuteQuery();
 * ctx.executeQuery()
 * .then(() => {})
 * .catch(() => {});
 */
function addExecuteQuery() {
    if (window && window.SP && window.SP.ClientContext && !window.SP.ClientContext.executeQuery) {
        window.SP.ClientContext.prototype.executeQuery = function () {
            var ctx = this;
            return new Promise(function (resolve, reject) {
                ctx.executeQueryAsync(function () {
                    resolve.apply(undefined, arguments);
                }, function () {
                    reject.apply(undefined, arguments);
                });
            });
        };
    }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/util/sp/addExecuteQuery.js
// module id = 1037
// module chunks = 0